import { Scenario } from '../../state/interfaces'
import { getAnswerProviderByName } from '../../answers'
import { Parser } from './interfaces'
import { isObject } from 'lodash'

import { AnswersProviders, AnswersProviderWithOptions } from '../../answers/interfaces'

export const answerParser: Parser = async ({ scenario, state }): Promise<Scenario> => {
  const newSteps = await Promise.all(
    scenario.steps.map(async (step) => {
      const { answersProvider, ...stepProps } = step

      if (answersProvider) {
        let answerProviderName: AnswersProviderWithOptions['provider']
        let answerProviderOptions: AnswersProviderWithOptions['options']

        if (isWithOptions(answersProvider)) {
          ;({ provider: answerProviderName, options: answerProviderOptions } = answersProvider)
        } else {
          answerProviderName = answersProvider
        }

        const provider = getAnswerProviderByName(answerProviderName, scenario)

        if (provider) {
          return {
            ...stepProps,
            answersProvider,
            answers: await provider(state, answerProviderOptions),
          }
        }
      }

      return step
    }),
  )

  return {
    ...scenario,
    steps: newSteps,
  }
}

const isWithOptions = (
  answerProvider: AnswersProviders | AnswersProviderWithOptions,
): answerProvider is AnswersProviderWithOptions => {
  return isObject(answerProvider)
}
